import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'components/UI/DatePicker/DatePicker';
import { EventFilters } from 'components/UI/EventFilters/EventFilters';
import { EventFiltersContext } from 'components/Shared/EventFiltersProvider';

export const EventCalendarFiltersContainer = (props) => {
  const { CalendarData } = props;
  const { setStartDate } = useContext(EventFiltersContext);

  const dateClickHandler = (date) => {
    setStartDate(date);
  };

  const removeTimezonesFromCalendar = () => {
    const timezoneRegex = /^(.*)T.*$/g;

    CalendarData.Years.forEach((years) =>
      years.Months.forEach((month) =>
        month.Days.forEach((day) => {
          // Change '2022-08-26T00:00:00+10:00' to '2022-08-26' for Day values
          const dateValueWithNoTimezone = day.DateValue.replace(timezoneRegex, '$1');
          day.DateValue = dateValueWithNoTimezone;
        })
      )
    );
  };

  useEffect(() => {
    removeTimezonesFromCalendar();
  }, []);

  return (
    <div className="event-filters-container">
      <DatePicker CalendarData={CalendarData} dateClickHandler={dateClickHandler} />
      <EventFilters {...props} />
    </div>
  );
};

EventCalendarFiltersContainer.propTypes = {
  CalendarData: PropTypes.object,
};
